export const LIGHTMAP_SCENE_EXPORT_VERSION = 3;
export const GENESYS_LIGHTMAPPER_SCENE_EXPORT_VERSION = LIGHTMAP_SCENE_EXPORT_VERSION;

export type LightmapSceneExportCoordinateSystem = 'Blender Z-up';

export type LightmapSceneExportAlphaMode = 'OPAQUE' | 'MASK' | 'BLEND';

export type LightmapSceneExportMaterialMaps = Partial<Record<
  'map' | 'normalMap' | 'roughnessMap' | 'metalnessMap' | 'emissiveMap' | 'alphaMap' | 'aoMap',
  string
>>;

export type LightmapSceneExportMaterialSnapshot = {
  color?: [number, number, number];
  opacity?: number;
  transparent?: boolean;
  alphaTest?: number;
  roughness?: number;
  metalness?: number;
  emissive?: [number, number, number];
  emissiveIntensity?: number;
  alphaMode?: LightmapSceneExportAlphaMode;
  maps?: LightmapSceneExportMaterialMaps;
};

export type LightmapSceneExportObjectBase = {
  lightmapTargetId: string;
  actorUuid: string;
  componentUuid: string;
  componentType: string;
  meshIndex: number;
  displayName: string;
  position: [number, number, number];
  rotation: [number, number, number];
  scale: [number, number, number];
  matrixWorldBlender: number[];
  material?: LightmapSceneExportMaterialSnapshot;
};

export type LightmapSceneExportMeshObject = LightmapSceneExportObjectBase & {
  type: 'mesh';
  vertices: number[];
  indices?: number[];
  uvs?: number[];
};

export type LightmapSceneExportModelObject = LightmapSceneExportObjectBase & {
  type: 'model';
  modelUrl: string;
  sourceIndexed: boolean;
};

export type LightmapSceneExportObject =
  | LightmapSceneExportMeshObject
  | LightmapSceneExportModelObject;

export type LightmapSceneExportLightType =
  | 'directional'
  | 'point'
  | 'spot'
  | 'hemisphere'
  | 'rectArea'
  | 'ambient';

export type LightmapSceneExportLight = {
  exportLightId: string;
  type: LightmapSceneExportLightType;
  name: string;
  color: [number, number, number];
  intensity: number;
  matrixWorldBlender: number[];
  directionBlender: [number, number, number];
  castShadow: boolean;
  distance?: number;
  decay?: number;
  angle?: number;
  penumbra?: number;
  width?: number;
  height?: number;
  groundColor?: [number, number, number];
};

export type LightmapSceneExport = {
  version: typeof LIGHTMAP_SCENE_EXPORT_VERSION;
  coordinateSystem: LightmapSceneExportCoordinateSystem;
  runId: string;
  objects: LightmapSceneExportObject[];
  lights: LightmapSceneExportLight[];
};

export type GenesysLightmapperSceneExport = LightmapSceneExport;
export type GenesysLightmapperSceneExportAlphaMode = LightmapSceneExportAlphaMode;
export type GenesysLightmapperSceneExportMaterialMaps = LightmapSceneExportMaterialMaps;
export type GenesysLightmapperSceneExportMaterialSnapshot = LightmapSceneExportMaterialSnapshot;
export type GenesysLightmapperSceneExportObjectBase = LightmapSceneExportObjectBase;
export type GenesysLightmapperSceneExportMeshObject = LightmapSceneExportMeshObject;
export type GenesysLightmapperSceneExportModelObject = LightmapSceneExportModelObject;
/** @deprecated Use {@link GenesysLightmapperSceneExportModelObject} — v3 export uses `type: 'model'`. */
export type GenesysLightmapperSceneExportGltfObject = LightmapSceneExportModelObject;
export type GenesysLightmapperSceneExportObject = LightmapSceneExportObject;
export type GenesysLightmapperSceneExportLightType = LightmapSceneExportLightType;
export type GenesysLightmapperSceneExportLight = LightmapSceneExportLight;
